import type { VariableEntity, VariableNode } from 'services/entities/VariablesEntity';
import { formatCurrencyValue } from './formatCurrencyValue';
import type { FlattenedOption } from 'components/editor/variables/types';

const priceRelatedVariables = ['total'];
const dateVariables = ['date_accepted', 'date_submitted', 'date_expiry'];

function formatIsoDate(value: string | number): string {
  const valueStr = String(value);
  const date = new Date(valueStr);
  return !isNaN(date.getTime()) ? date.toISOString().slice(0, 10) : valueStr;
}

function isFormattableDateValue(value: unknown): value is string | number {
  return (typeof value === 'string' || typeof value === 'number') && Boolean(value);
}

export function formatVariableValueWithPricing(variable: VariableNode | VariableEntity | FlattenedOption, currency?: string): string {
  const isDocumentPriceVariable = priceRelatedVariables.some((term) => variable.name.toLowerCase().includes(term));
  const isDateVariable = dateVariables.includes(variable.name);

  if (isDocumentPriceVariable) return formatCurrencyValue(Number(variable.value), 'en-US', currency);
  if (isDateVariable && isFormattableDateValue(variable.value)) return formatIsoDate(variable.value);
  // `shape.format === 'date'` is the real driver; `shape.type` is excluded because CRM
  // nodes commonly carry `shape.type: 'string'`, making it an unsafe sole discriminator.
  if (variable.type === 'date' && variable.shape?.format === 'date' && isFormattableDateValue(variable.value))
    return formatIsoDate(variable.value);
  return (variable.value || '').toString();
}
